import React from "react";
import { withRouter, RouteChildrenProps } from "react-router";
import ManageIntegrations from "../pages/ManageIntegrations";
import IntegrationDetailWithData from "../integrations/IntegrationDetailWithData";
import IntegrationDetail from "../integrations/IntegrationDetail";
import AuthorizeRoute from "../api-authorization/AuthorizeRoute";

const IntegrationRoutes = (props: RouteChildrenProps) => {
  let path = "";
  const { match } = props;
  if (match && match.path) {
    path = match.path;
  }

  return (
    <>
      <AuthorizeRoute exact path={`${path}/my`} component={ManageIntegrations} />
      <AuthorizeRoute exact path={`${path}/details/:id`} component={IntegrationDetailWithData} />
      <AuthorizeRoute exact path={`${path}/add`} component={IntegrationDetail} />
    </>
  );
};

export default withRouter(IntegrationRoutes);
